<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="invenclispre"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="enclispreconf" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar"
            [botonBorrar]="botonBorrar" [botonRegresar]="false" [barraBotonesDesplaz]="true" [barraBotones3]="true"
            [barraBotonesAsiCon]="true" [barraBotones5]="true"
            [botonBuscarPermanente]="true" [botonDescargaPermanente]="true" [botonactlispre]="true"
            [botonAutorizarPermanente]="true"
            ></app-invmaebarra>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Número:</span>
                        </div>
                        <div class="p-col-1">
                            <label for="ENCLISPRE_NUMERO"></label>
                            <input class="frm" id="ENCLISPRE_NUMERO" type="text" pInputText disabled [(ngModel)]="invenclispreService.enclispre[indicador].ENCLISPRE_NUMERO"
                                style="color: blue; font-weight: bold;" autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <span>Estado:</span>
                            
                        </div>
                        <div class="p-col-2">
                            <label for="lblbestado"></label>
                            <input class="frm" id="lblbestado" type="text" pInputText disabled [(ngModel)]="lblbestado"
                                style="color: blue; font-weight: bold;" autocomplete="off">
                            
                        </div>
                        <div class="p-col-1">
                           
                        </div>
                        <div class="p-col-3">
                            
                        </div>
                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div>
                                <div class="p-col-1">
									<p-calendar id="ENCLISPRE_FECHA"
										[inputStyle]="{width: '100%', height: '20px'}"
										[(ngModel)]="invenclispreService.enclispre[indicador].ENCLISPRE_FECHA"
										[readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()">
									</p-calendar>
								</div>
                                <div class="p-col-1">
                                    <span>Concepto:</span>
                                </div>
                                <div class="p-col-5">
									<label for="ENCLISPRE_CONCEPTO"></label>
									<input class="frm" id="ENCLISPRE_CONCEPTO" type="text" pInputText
										[(ngModel)]="invenclispreService.enclispre[indicador].ENCLISPRE_CONCEPTO"
										(keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
										autocomplete="off">
								</div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <app-aggridsaci 
            [width]=""
            [height]="80" 
            [enableSorting]="false" 
            [enableFilter]="true"
            [rowData]="invenclispreService.detlispre" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsDetlispre"
            [defaultColDef]="defaultDetlispre" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="true"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
            [solobotoneliminar]="false"
            [btnsubirxls]="false"
            (selected)="seleccionDetlispre($event)" 
            [tipodetalle]=""
            [botonBorrar]="true"
            (cambios)="cambio($event)"
            [CC]="true"
            >
            </app-aggridsaci>
            
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<input #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;" accept=".xls, .xlsx"
    (change)="onBasicUpload(inputFile.files)" />

    <p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
					 [where]="where"
					 [busquedaParams]="busquedacampos"
					 (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<p-dialog header="Clave de Autorización" [(visible)]="displayDialogAutorizacion"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		 
		  [style]="{width: '40vw', height: 'auto'} ">
	<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="autorizacion"></p-toast>
	<div class="divgrups">
		<div class="p-grid">
			<div class="p-col-12">
				<div class="p-grid">
					<div class="p-col-1"></div>
					<div class="p-col-4">
						<label for="clave" style="font-weight: bold">Clave de Autorización:</label>
					</div>
					<div class="p-col-2"></div>
					<div class="p-col-4">
						<input type="password" pInputText id="clave" [(ngModel)]="claveAuth"
							   (keydown.enter)="comprobarClave()" placeholder="Ingrese la clave">
					</div>
					<div class="p-col-1"></div>
				</div>
			</div>
		</div>
	</div>
</p-dialog>